/**
 * Archive Sale 2026 — Collection UX JavaScript V6
 * AJAX category filtering + Quick Add to Bag
 */
(function() {
  'use strict';

  var gridOuter = document.querySelector('[data-products-grid]');
  if (!gridOuter) return;

  var bar = document.querySelector('[data-archive-category-bar]');

  // ── AJAX Category Filter ──────────────────────────────────────

  if (bar) {
    var isFiltering = false;

    // Scroll active pill into view on load (mobile)
    var activePill = bar.querySelector('.archive-category-bar__pill--active');
    if (activePill) {
      var inner = bar.querySelector('.archive-category-bar__inner');
      if (inner) {
        var pillLeft = activePill.offsetLeft;
        var pillWidth = activePill.offsetWidth;
        var containerWidth = inner.offsetWidth;
        var scrollTarget = pillLeft - (containerWidth / 2) + (pillWidth / 2);
        inner.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
      }
    }

    bar.addEventListener('click', function(e) {
      var pill = e.target.closest('[data-filter-pill]');
      if (!pill || isFiltering) return;
      e.preventDefault();

      var filterValue = pill.getAttribute('data-filter-value');
      var collectionUrl = bar.getAttribute('data-collection-url');
      // Preserve existing sidebar filters when clicking pills
      var currentUrl = new URL(window.location.href);
      // If pill is "All", start fresh from collection URL
      if (!filterValue) {
        currentUrl = new URL(collectionUrl, window.location.origin);
      } else {
        // Keep all existing params but update product_type
        if (currentUrl.pathname !== new URL(collectionUrl, window.location.origin).pathname) {
          currentUrl = new URL(collectionUrl, window.location.origin);
        }
        currentUrl.searchParams.set('filter.p.product_type', filterValue);
      }
      // Reset page param (new filter = page 1)
      currentUrl.searchParams.delete('page');
      var url = currentUrl.pathname + currentUrl.search;
      if (!url) return;

      // Toggle active state immediately
      var allPills = bar.querySelectorAll('[data-filter-pill]');
      allPills.forEach(function(p) {
        p.classList.remove('archive-category-bar__pill--active');
      });
      pill.classList.add('archive-category-bar__pill--active');

      // AJAX fetch
      filterByUrl(url);
    });

    // Handle back/forward navigation
    window.addEventListener('popstate', function() {
      filterByUrl(window.location.href, true);
    });

    function filterByUrl(url, isPopstate) {
      isFiltering = true;
      gridOuter.style.opacity = '0.4';
      gridOuter.style.transition = 'opacity 0.2s ease';

      fetch(url)
        .then(function(res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-products-grid]');
          var newBar = doc.querySelector('[data-archive-category-bar]');

          if (newGrid) {
            gridOuter.innerHTML = newGrid.innerHTML;
          }

          // Sync sidebar filters from server response
          var newSidebar = doc.querySelector('[data-collection-sidebar]');
          var currentSidebar = document.querySelector('[data-collection-sidebar]');
          if (newSidebar && currentSidebar) {
            currentSidebar.innerHTML = newSidebar.innerHTML;
          }

          // Update section data attributes for pagination
          var newSection = doc.querySelector('[data-section-type="collection"]');
          var currentSection = document.querySelector('[data-section-type="collection"]');
          if (newSection && currentSection) {
            currentSection.setAttribute('data-current-page', newSection.getAttribute('data-current-page') || '1');
            currentSection.setAttribute('data-total-pages', newSection.getAttribute('data-total-pages') || '1');
          }
          // Also update .collection-products for infinite scroll
          var newCollProd = doc.querySelector('.collection-products');
          var curCollProd = document.querySelector('.collection-products');
          if (newCollProd && curCollProd) {
            curCollProd.setAttribute('data-current-page', newCollProd.getAttribute('data-current-page') || '1');
            curCollProd.setAttribute('data-total-pages', newCollProd.getAttribute('data-total-pages') || '1');
          }

          // Update pill active states from server response
          if (newBar && bar) {
            var newPills = newBar.querySelectorAll('[data-filter-pill]');
            var currentPills = bar.querySelectorAll('[data-filter-pill]');
            newPills.forEach(function(np, i) {
              if (currentPills[i]) {
                if (np.classList.contains('archive-category-bar__pill--active')) {
                  currentPills[i].classList.add('archive-category-bar__pill--active');
                } else {
                  currentPills[i].classList.remove('archive-category-bar__pill--active');
                }
              }
            });
          }

          if (!isPopstate) {
            history.pushState({ archiveFilter: true }, '', url);
          }

          gridOuter.style.opacity = '1';
          isFiltering = false;

          // Re-init infinite scroll with new filtered content
          if (window.siedresInfiniteScroll) {
            window.siedresInfiniteScroll.destroy();
          }
          window.siedresInfiniteScroll = new SmoothInfiniteScroll();

          // Notify other scripts that filters changed
          document.dispatchEvent(new CustomEvent('collection:filters-changed'));

          // Smooth scroll to grid
          var barRect = bar.getBoundingClientRect();
          if (barRect.top < 0) {
            bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          // Re-init swipers if theme has them
          if (typeof window.theme !== 'undefined' && typeof window.theme.initProductGridSwipers === 'function') {
            window.theme.initProductGridSwipers();
          }
          // Trigger AOS refresh
          if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
            AOS.refresh();
          }
        })
        .catch(function() {
          // Graceful fallback: full page navigation
          window.location.href = url;
        });
    }
  }

  // ── Quick Add: bag icon (panel open) + size pills (direct add) ──

  // Direct add to cart (used by hover size pills AND panel add button)
  function addVariantToCart(variantId) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then(function(res) {
      if (!res.ok) throw new Error(res.status);
      return res.json();
    }).then(function(json) {
      // Trigger theme's own cart refresh pipeline → drawer auto-opens
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      }, 150);
      return json;
    });
  }

  // Hover size pill click → direct add (no panel)
  gridOuter.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-quick-add-pill]');
    if (pill && !pill.disabled) {
      e.preventDefault();
      e.stopPropagation();
      if (pill.classList.contains('quick-add-size-pill--loading')) return;

      var variantId = pill.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = pill.textContent;
      pill.classList.add('quick-add-size-pill--loading');
      pill.textContent = '…';

      addVariantToCart(variantId).then(function() {
        pill.textContent = '✓';
        setTimeout(function() {
          pill.classList.remove('quick-add-size-pill--loading');
          pill.textContent = originalText;
        }, 1400);
      }).catch(function() {
        pill.classList.remove('quick-add-size-pill--loading');
        pill.textContent = originalText;
      });
      return;
    }

    // Bag icon click → open slide panel with this product's data
    var bag = e.target.closest('[data-quick-add-trigger]');
    if (bag) {
      e.preventDefault();
      e.stopPropagation();
      var card = bag.closest('[data-quick-add-card]');
      if (!card) return;
      var dataScript = card.querySelector('script[data-quick-add-product]');
      if (!dataScript) return;
      try {
        var productData = JSON.parse(dataScript.textContent);
        openQuickAddPanel(productData);
      } catch (err) {
        // Fallback: go to product page
        window.location.href = card.getAttribute('data-product-url');
      }
    }
  });

  // ── Slide Panel ────────────────────────────────────────────────

  var panel = document.querySelector('[data-quick-add-panel]');
  var panelContent = panel ? panel.querySelector('[data-quick-add-content]') : null;

  function findSizeOption(product) {
    return (product.options || []).find(function(o) {
      var n = (o.name || '').toLowerCase();
      return n === 'size' || n === 'beden';
    });
  }

  function findColorOption(product) {
    return (product.options || []).find(function(o) {
      var n = (o.name || '').toLowerCase();
      return n === 'color' || n === 'colour' || n === 'renk';
    });
  }

  function variantsByColor(product, selectedColor) {
    var colorOpt = findColorOption(product);
    if (!colorOpt || !selectedColor) return product.variants;
    var pos = colorOpt.position;
    return product.variants.filter(function(v) {
      return v['option' + pos] === selectedColor;
    });
  }

  function renderPanel(product, state) {
    var sizeOpt = findSizeOption(product);
    var colorOpt = findColorOption(product);
    var selectedColor = state.selectedColor;
    var selectedVariantId = state.selectedVariantId;
    var filteredVariants = variantsByColor(product, selectedColor);

    var availableVariants = product.variants.filter(function(v) { return v.available; });
    var isSingleVariant = product.variants.length === 1 || (availableVariants.length === 1 && product.variants.length === 1);

    var imageHtml = '';
    if (product.images && product.images.length > 0) {
      var img = product.images[0];
      imageHtml =
        '<div class="quick-add-panel__image-wrap">' +
          '<div class="quick-add-panel__image-aspect">' +
            '<img src="' + img.url + '" alt="' + (img.alt || product.title) + '" loading="eager">' +
          '</div>' +
        '</div>';
    }

    var priceHtml =
      '<div class="quick-add-panel__price-row">' +
        '<span>' + product.price + '</span>' +
        (product.on_sale && product.compare_at_price
          ? '<span class="quick-add-panel__price--compare">' + product.compare_at_price + '</span>'
          : '') +
      '</div>';

    var colorHtml = '';
    if (colorOpt && colorOpt.values.length > 1) {
      var colorPos = colorOpt.position;
      var availableColors = {};
      product.variants.forEach(function(v) {
        var c = v['option' + colorPos];
        if (c) availableColors[c] = availableColors[c] || v.available;
      });
      var colorButtons = colorOpt.values.map(function(c) {
        var avail = availableColors[c];
        var isSel = c === selectedColor;
        return '<button type="button" class="quick-add-panel__option' +
          (isSel ? ' is-selected' : '') +
          (avail ? '' : ' quick-add-panel__option--out') + '"' +
          ' data-color-value="' + c + '"' +
          (avail ? '' : ' disabled') +
          ' aria-label="' + c + (avail ? '' : ', sold out') + '">' + c + '</button>';
      }).join('');
      colorHtml =
        '<div>' +
          '<p class="quick-add-panel__section-label">Color' + (selectedColor ? ' — ' + selectedColor : '') + '</p>' +
          '<div class="quick-add-panel__options" data-color-group>' + colorButtons + '</div>' +
        '</div>';
    }

    var sizeHtml = '';
    if (sizeOpt && !isSingleVariant) {
      var sizePos = sizeOpt.position;
      // Build size buttons from filtered variants (per selected color)
      var sizeButtons = sizeOpt.values.map(function(sz) {
        // Find a variant for this size in filtered set
        var variant = filteredVariants.find(function(v) { return v['option' + sizePos] === sz; });
        if (!variant) return '';
        var avail = variant.available;
        var vNorm = (sz + '').toLowerCase().trim();
        // Skip rare-size OOS
        if ((vNorm === 'xxs' || vNorm === 'xxl' || vNorm === 'xl' || vNorm === '42') && !avail) return '';
        var isSel = selectedVariantId === variant.id;
        return '<button type="button" class="quick-add-panel__option' +
          (isSel ? ' is-selected' : '') +
          (avail ? '' : ' quick-add-panel__option--out') + '"' +
          ' data-variant-id="' + variant.id + '"' +
          (avail ? '' : ' disabled') +
          ' aria-label="Size ' + sz + (avail ? '' : ', sold out') + '">' + sz + '</button>';
      }).join('');
      sizeHtml =
        '<div>' +
          '<p class="quick-add-panel__section-label">Select a size</p>' +
          '<div class="quick-add-panel__options" data-size-group>' + sizeButtons + '</div>' +
        '</div>';
    }

    var addBtnHtml;
    if (selectedVariantId) {
      addBtnHtml = '<button type="button" class="quick-add-panel__add-btn" data-panel-add>Add to bag</button>';
    } else if (isSingleVariant && availableVariants[0]) {
      addBtnHtml = '<button type="button" class="quick-add-panel__add-btn" data-panel-add data-variant-id="' + availableVariants[0].id + '">Add to bag</button>';
    } else {
      addBtnHtml = '<button type="button" class="quick-add-panel__add-btn" disabled>Select a size</button>';
    }

    var viewLinkHtml = '<a href="' + product.url + '" class="quick-add-panel__view-link">View product</a>';
    var errorHtml = '<p class="quick-add-panel__error" data-panel-error hidden></p>';

    panelContent.innerHTML =
      imageHtml +
      '<div class="quick-add-panel__body">' +
        '<h3 class="quick-add-panel__title">' + product.title + '</h3>' +
        priceHtml +
        colorHtml +
        sizeHtml +
        errorHtml +
        addBtnHtml +
        viewLinkHtml +
      '</div>';
  }

  var currentPanelState = null;
  var currentPanelProduct = null;

  function openQuickAddPanel(product) {
    if (!panel || !panelContent) return;

    var sizeOpt = findSizeOption(product);
    var colorOpt = findColorOption(product);

    // Initial state
    var initialColor = null;
    if (colorOpt && colorOpt.values.length > 1) {
      // Pick first color that has any available variant
      for (var i = 0; i < colorOpt.values.length; i++) {
        var c = colorOpt.values[i];
        var hasAvail = product.variants.some(function(v) {
          return v['option' + colorOpt.position] === c && v.available;
        });
        if (hasAvail) { initialColor = c; break; }
      }
    }

    var availableVariants = product.variants.filter(function(v) { return v.available; });
    var initialVariantId = null;
    if (product.variants.length === 1) initialVariantId = product.variants[0].id;
    else if (availableVariants.length === 1) initialVariantId = availableVariants[0].id;

    currentPanelProduct = product;
    currentPanelState = {selectedColor: initialColor, selectedVariantId: initialVariantId};
    renderPanel(product, currentPanelState);

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quick-add-open');
  }

  function closeQuickAddPanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('quick-add-open');
    currentPanelState = null;
    currentPanelProduct = null;
  }

  if (panel) {
    panel.addEventListener('click', function(e) {
      if (e.target.closest('[data-quick-add-close]')) {
        e.preventDefault();
        closeQuickAddPanel();
        return;
      }

      // Color selection
      var colorBtn = e.target.closest('[data-color-value]');
      if (colorBtn && !colorBtn.disabled && currentPanelProduct) {
        currentPanelState.selectedColor = colorBtn.getAttribute('data-color-value');
        currentPanelState.selectedVariantId = null;
        renderPanel(currentPanelProduct, currentPanelState);
        return;
      }

      // Size selection
      var sizeBtn = e.target.closest('[data-variant-id]');
      if (sizeBtn && sizeBtn.classList.contains('quick-add-panel__option') && !sizeBtn.disabled && currentPanelProduct) {
        currentPanelState.selectedVariantId = sizeBtn.getAttribute('data-variant-id');
        renderPanel(currentPanelProduct, currentPanelState);
        return;
      }

      // Add to bag from panel
      var addBtn = e.target.closest('[data-panel-add]');
      if (addBtn && !addBtn.disabled) {
        e.preventDefault();
        var variantId = currentPanelState && currentPanelState.selectedVariantId;
        if (!variantId) variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        var errEl = panelContent.querySelector('[data-panel-error]');
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        addBtn.disabled = true;
        var orig = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        addVariantToCart(variantId).then(function() {
          addBtn.textContent = 'Added';
          setTimeout(function() {
            closeQuickAddPanel();
          }, 350);
        }).catch(function() {
          addBtn.textContent = orig;
          addBtn.disabled = false;
          if (errEl) { errEl.hidden = false; errEl.textContent = 'Could not add to bag. Please try again.'; }
        });
      }
    });

    // ESC to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        closeQuickAddPanel();
      }
    });
  }

})();
